
import { Component, Mixins, Prop } from 'vue-property-decorator'
import scroll from '@/mixins/scroll'
import {
  confirmRefund,
  getReturnOrderList,
  ReturnOrderListDto,
  ReturnOrderParamsDTO
} from '@/api/shopOrder'
import ReturnOrderFilter from '@/views/industryMall/order/returnOrder/OrderFilter.vue'
import { Getter } from 'vuex-class'

import { getStoreReturnOrder, cancelStoreReturnOrder } from '@/api/industryMall'
import goodsListPopup from '../template/goodsListPopup.vue'

@Component({
  name: 'ReturnOrderList',
  components: { ReturnOrderFilter, goodsListPopup }
})
export default class ReturnOrderList extends Mixins(scroll) {
  @Getter companyId!: string
  @Getter partnerCompanyId!: string // 合作方编号
  @Prop({default:''}) orderId?: string

  refreshing = false
  loading = false
  finished = false
  params: { [x: string]: any } = {
    // companyId: '',
    partnerCompanyId: '',
    pageIndex: 1,
    pageSize: 20
  }
  orderList: ReturnOrderListDto[] = []
  clickedItemIndex = 0

  created() {
    this.params.companyId = this.companyId
    this.params.partnerCompanyId = this.partnerCompanyId
    this.getOrderList()
  }

  mounted() {
    this.$addScrollListener('.return-order-list')
  }

  activated() {
    this.$setScrollY()
    this.handleActivated()
  }

  deactivated() {
    this.$removeScrollListener()
  }

  /**
   * @description 从订单详情返回刷新当前页数据，当前页之后的数据清除
   **/
  handleActivated() {
    const pageIndex = Math.trunc(this.clickedItemIndex / this.params.pageSize) + 1
    const params = { ...this.params,orderId: this.orderId, pageIndex }
    getStoreReturnOrder(params).then((res) => {
      if (pageIndex > 1) {
        const preData = this.orderList.slice(0, (pageIndex - 1) * this.params.pageSize)
        this.orderList = JSON.parse(JSON.stringify(preData.concat(res.data.records)))
      } else {
        this.orderList = res.data.records
      }
      this.params.pageIndex = pageIndex
      if (Number(pageIndex) >= res.data.totalPages) {
        this.finished = true
      } else {
        this.finished = false
      }
    })
  }

  handleBack() {
    // this.$router.replace('/shopOrder')
    this.$router.go(-1)
  }

  /**
   * @description 客户取消退单
   * @param returnOrderId
   */
  cancelOrder(returnOrderId: string) {
    cancelStoreReturnOrder({ returnOrderId }).then((res) => {
      // console.log('cancelStoreReturnOrder',res)
      this.$toast('取消退货成功')
      this.onRefresh()
    })
  }

  getOrderList() {
    // getReturnOrderList(this.params).then((res) => {
    getStoreReturnOrder({ ...this.params,orderId:this.orderId })
      .then((res) => {
        console.log('1--------')
        if (this.refreshing) {
          this.orderList = []
        }
        this.orderList = this.orderList.concat(res.data.records) || []
        if (Number(this.params.pageIndex) >= res.data.totalPages) {
          this.finished = true
        } else {
          this.finished = false
        }
      })
      .catch(() => {
        this.loading = false
      })
      .finally(() => {
        console.log('2----------')
        this.loading = false
        this.refreshing = false
      })
  }

  getFilterParams(data: ReturnOrderParamsDTO) {
    this.params = Object.assign(this.params, data)
    this.getOrderList()
  }

  /**
   * 下拉刷新
   * */
  onRefresh() {
    this.params.pageIndex = 1
    this.refreshing = true
    this.getOrderList()
  }

  /**
   * 上拉加载更多
   */
  onLoad() {
    this.params.pageIndex++
    this.loading = true
    this.getOrderList()
  }

  orderFilter() {
    ;(this.$refs.orderFilter as any).show()
  }

  toDetail(returnOrderId: string, index: number) {
    this.clickedItemIndex = index
    this.$router.push({
      path: '/mallReturnOrderDetail',
      query: {
        returnOrderId
      }
    })
  }

  /**
   * 确认收款
   * @param data 订单数据
   */
  confirmPay(data: ReturnOrderListDto) {
    const obj = {
      companyId: this.companyId,
      currRouteId: data.currRouteId,
      retunOrderId: data.returnOrderId,
      shopId: data.shopCompanyId
    }
    confirmRefund(obj)
      .then((res) => {
        let msg = ''
        if (res.code === '000000') {
          msg = '确认收款成功'
        } else if (res.code === '000002') {
          msg = '退货单状态已变更'
        }
        this.$dialog
          .alert({
            message: msg
          })
          .then(() => {
            this.getOrderList()
          })
      })
      .catch(() => {})
  }
  showGoodsList (list: any) {
    (this.$refs.goodsList as any).showPop(list)
  }
}
